import PropTypes from 'prop-types';
import { Navigate } from 'react-router';
// hooks
import useAuth from 'src/hooks/useAuth';
// routes
import {
  COMPLIANCE_PATHS,
  HM_DASHBOARD,
  PATH_DASHBOARD,
} from 'src/routes/paths';
import { RENTER_PATHS } from 'src/routes/renterPaths';
import { shallowEqual, useSelector } from 'react-redux';

// ----------------------------------------------------------------------

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default function GuestGuard({ children }) {
  const { isAuthenticated, user } = useAuth();
  const isNewRentersExperienceEnabled = useSelector(
    (state) => state.featureFlags.flags.ENABLE_NEW_RENTER_EXPERIENCE,
    shallowEqual
  );

  if (isAuthenticated) {
    const roles =
      user.groups?.map((role) => role.name.toString().toLowerCase()) || [];

    if (roles.includes('compliance') || roles.includes('owner')) {
      return <Navigate to={COMPLIANCE_PATHS.root} />;
    } else if (roles.includes('audit') || roles.includes('administration')) {
      return <Navigate to={PATH_DASHBOARD.root} />;
    } else if (roles.includes('resident')) {
      if (isNewRentersExperienceEnabled && user?.sees_new_experience) {
        return <Navigate to={`/${RENTER_PATHS.HOME}`} />;
      }
      return <Navigate to={HM_DASHBOARD.root} />;
    }
  }

  return <>{children}</>;
}
